import axios from 'axios'
import infra from '@/util/infra'

axios.defaults.baseURL = infra.obterUrlApi()
axios.defaults.withCredentials = true

axios.interceptors.response.use(function (response) {
  const status = response.status
  switch (status) {
    case 201:
      return infra.tratar201(response)
  }
  return response
}, function (responseError) {
  const status = responseError.response.status
  switch (status) {
    case 401:
      return infra.tratar401(responseError)
    case 413:
      return infra.tratar413(responseError)
    default:
      return Promise.reject(responseError)
  }
})

export { axios }
